import { AbstractSceneTransition } from "appworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Contract } from "appworks/utils/contracts/contract";
import { gameLayers } from "game-layers";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class TGRPCRewatchBetBarTransition extends AbstractSceneTransition {

    public in(): Contract<void> {
        return Contract.wrap(() => {
            if (PartnerConnectManager.getConfig()?.mode === "REWATCH") {

                gameLayers.BetBar.elements.active.balance_label.visible = false;
                gameLayers.BetBar.elements.active.balance_value.visible = false;

                gameLayers.BetBar.elements.active.stake_up.setEnabled(false);
                gameLayers.BetBar.elements.active.stake_down.setEnabled(false);
            }
        });
    }
}
